export const convertSettlementsResponse = (settlements) => {
  return settlements.map((settlement) => ({
    ...settlement,
    balanceType: settlement.adjustment_amount >= 0 ? 'credit' : 'debit',
  }));
};
